var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorGold({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.20639 6.33972L4.20598 6.33928L4.20393 6.33797L4.20639 6.33972ZM12 4.96281L11.0956 2.40807L7.80836 0.5L0.996175 4.37696L0 7.21872L4.01584 9.5L4.08182 6.40797L0.957656 4.5034L1.22565 4.65479L1.0728 4.56072L1.61863 4.87049L1.12198 4.56072L4.20598 6.33928L10.8465 2.67453L9.7835 3.29757L11.028 2.61896L8.56481 4.01162L4.28917 6.51736L4.01543 9.49956L11.9996 4.96194L12 4.96281ZM4.33916 5.44759L2.54064 4.4229L4.28999 5.00044L9.64581 2.46276L4.33916 5.44759Z",
    fill: "#FFD700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorGold);
export default __webpack_public_path__ + "static/media/color_gold.659f25a17a079f843246029cb68872a6.svg";
export { ForwardRef as ReactComponent };